// extracted by extract-css-chunks-webpack-plugin
module.exports = {"image":"ExploreCollectionModal-0a09a437a73d8d0a","textCenter":"ExploreCollectionModal-997ba95d2e370e59"};